import { AdminCampaignsService } from '@/services';
import type { AgentVariantInput } from '@/services';

// At most this many variants may be active at once (server-enforced).
export const MAX_ACTIVE_AGENT_VARIANTS = 5;

export type {
  AgentVariantInput,
  AgentVariantsResponse,
  AgentVariantResponse as AgentVariant,
} from '@/services';

export const getAgentVariants = (campaignId: string) =>
  AdminCampaignsService.getAgentVariantsApiAdminCampaignsCampaignIdAgentVariantsGet(
    campaignId
  );

// Replace the campaign's entire variant set. An empty list clears all variants
// (the campaign falls back to its single default agent).
export const putAgentVariants = (
  campaignId: string,
  variants: AgentVariantInput[]
) =>
  AdminCampaignsService.replaceAgentVariantsApiAdminCampaignsCampaignIdAgentVariantsPut(
    campaignId,
    { variants }
  );
